import { Certificate } from '@sdir/httpclient/lib/clients/aps/personalcertificate';

export const CapitalizeString = (text: string): string => {
  return text.charAt(0).toUpperCase() + text.slice(1);
};

export const GetLocalizedCertificateName = (lang: string, certificate: Certificate): string => {
  const localizedName = certificate.name?.find((n) => n.language === lang)?.value || '';
  return CapitalizeString(localizedName);
};

export const getReceiptLanguage = (language: string) => {
  if (language === 'en') return 'EN';
  if (['no', 'nb', 'nn'].includes(language)) return 'NO';
  return 'EN';
};
